module.exports = __webpack_public_path__ + "ic-benefit.svg?02c8134c50410985079ef4d267f4acba";